import React, { useEffect, useState } from 'react';
import './ParentPeaceOfMind.css';
import { supabase } from "../supabaseClient";

const ParentPeaceOfMind = () => {
  const [features, setFeatures] = useState([]);

  useEffect(() => {
    const getFeatures = async () => {
      const res = await supabase.from("AboutTwo").select("*");
      setFeatures(res.data);
    };
    getFeatures();
  }, []);

  return (
    <section className="peace-container">
      <div className="header-badge">
        <span role="img" aria-label="family">👨‍👩‍👧‍👦</span> For Parents & Guardians
      </div>
      <h2 className="peace-title">Peace of Mind for Parents</h2>
      <div className="features-grid">
        {features.map((feature) => (
          <div key={feature.id} className="feature-item">
            <div className="check-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>
            <div className="feature-content">
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ParentPeaceOfMind;